<div class="modal-header">
  <div class="modal-title-wrapper">
    <h2 class="modal-title fw-bold">{{ eventClass.class_name }}</h2>
    <div class="class-meta d-flex gap-4 mt-2">
      @if (eventClass.start_date_time) {
        <span class="text-muted">
          <i class="fa fa-calendar me-2"></i>
          {{ formatDateDMYDots(eventClass.start_date_time) }}
        </span>
      }
      @if (eventClass.price) {
        <span class="text-muted">
          <i class="fa fa-money-bill me-2"></i>
          {{ eventClass.price }} {{ eventClass.price_currency }}
        </span>
      }
      <span class="text-muted">
        <i class="fa fa-users me-2"></i>
        {{ eventClass.event_class_registrations?.length || 0 }} {{ (eventClass.event_class_registrations?.length || 0) !== 1 ? ('manageEvent.viewRegistrations.registrationsPlural' | translate) : ('manageEvent.viewRegistrations.registrationSingular' | translate) }}
      </span>
    </div>
  </div>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<div class="modal-body">
  @if (eventClass.class_description) {
    <div class="alert alert-info d-flex align-items-center mb-6">
      <i class="fa fa-info-circle fs-2x me-3"></i>
      <div>{{ eventClass.class_description }}</div>
    </div>
  }

  <!-- Round Selector -->
  @if (rounds.length > 0) {
    <div class="d-flex align-items-center gap-3 mb-4">
      <span class="fw-semibold text-gray-600">{{ 'rounds.selectRound' | translate }}:</span>
      <div class="btn-group">
        @for (round of rounds; track round.round_id) {
          <button
            type="button"
            class="btn btn-sm"
            [class.btn-primary]="selectedRound?.round_id === round.round_id"
            [class.btn-light]="selectedRound?.round_id !== round.round_id"
            (click)="selectRound(round)"
          >
            {{ round.round_name || 'Round ' + round.round_number }}
          </button>
        }
      </div>
    </div>
  } @else {
    <div class="alert alert-warning d-flex align-items-center mb-4">
      <i class="fa fa-exclamation-triangle me-3"></i>
      <div>{{ 'results.noRoundsConfigured' | translate }}</div>
    </div>
  }

  @if ((eventClass.event_class_registrations?.length || 0) === 0) {
    <div class="text-center py-10">
      <i class="fa fa-users-slash fs-3x text-muted mb-5"></i>
      <h4 class="text-muted">{{ 'manageEvent.viewRegistrations.noRegistrationsTitle' | translate }}</h4>
      <p class="text-muted">{{ 'manageEvent.viewRegistrations.noRegistrationsText' | translate }}</p>
    </div>
  } @else {
    <!-- Registrations Table -->
    <div class="table-responsive">
      <table class="table table-row-bordered table-row-dashed gy-4 align-middle fw-bold">
        <thead class="fw-bold text-muted bg-light">
          <tr>
            <th class="ps-6">#</th>
            <th>{{ 'manageEvent.viewRegistrations.rider' | translate }}</th>
            <th>{{ 'manageEvent.viewRegistrations.horse' | translate }}</th>
            <th>{{ 'manageEvent.viewRegistrations.orderNumber' | translate }}</th>
            <th>{{ 'manageEvent.viewRegistrations.payment' | translate }}</th>
            <th>{{ 'manageEvent.viewRegistrations.registeredOn' | translate }}</th>
            <th>{{ 'manageEvent.viewRegistrations.notes' | translate }}</th>
            <th class="text-center">{{ 'manageEvent.viewRegistrations.score' | translate }}</th>
            <th class="text-end min-w-70px">{{ 'manageEvent.viewRegistrations.actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (registration of eventClass.event_class_registrations; track registration.class_registration_id; let i = $index) {
            <tr>
              <td class="ps-6 fw-semibold text-gray-700">{{ getRegistrationNumber(i) }}</td>
              <td>
                @if (registration.user) {
                  <div
                    class="d-flex flex-column cursor-pointer user-info-hover"
                    [ngbTooltip]="userTooltip"
                    placement="right"
                    container="body">
                    <span class="fw-semibold text-gray-800">
                      {{ registration.user.first_name }} {{ registration.user.last_name }}
                    </span>
                    @if (registration.user.email) {
                      <span class="text-muted fs-7">{{ registration.user.email }}</span>
                    }
                  </div>
                  <ng-template #userTooltip>
                    <div class="tooltip-content">
                      <div class="tooltip-header">{{ 'manageEvent.viewRegistrations.riderInfo' | translate }}</div>
                      <div class="tooltip-row">
                        <strong>{{ 'manageEvent.viewRegistrations.name' | translate }}:</strong> {{ registration.user.first_name }} {{ registration.user.last_name }}
                      </div>
                      @if (registration.user.email) {
                        <div class="tooltip-row">
                          <strong>{{ 'manageEvent.viewRegistrations.email' | translate }}:</strong> {{ registration.user.email }}
                        </div>
                      }
                      @if (registration.user.phone) {
                        <div class="tooltip-row">
                          <strong>{{ 'manageEvent.viewRegistrations.phone' | translate }}:</strong> {{ registration.user.phone }}
                        </div>
                      }
                      @if (registration.user.date_of_birth) {
                        <div class="tooltip-row">
                          <strong>{{ 'manageEvent.viewRegistrations.dateOfBirth' | translate }}:</strong> {{ formatDateDMYDots(registration.user.date_of_birth) }}
                        </div>
                      }
                      @if (registration.user.city || registration.user.country) {
                        <div class="tooltip-row">
                          <strong>{{ 'manageEvent.viewRegistrations.location' | translate }}:</strong> {{ registration.user.city }}@if(registration.user.city && registration.user.country){, }{{ registration.user.country }}
                        </div>
                      }
                      @if (registration.user.riding_club) {
                        <div class="tooltip-row">
                          <strong>{{ 'manageEvent.viewRegistrations.ridingClub' | translate }}:</strong> {{ registration.user.riding_club }}
                        </div>
                      }
                    </div>
                  </ng-template>
                } @else {
                  <span class="text-muted">N/A</span>
                }
              </td>
              <td>
                @if (registration.horse) {
                  <div
                    class="d-flex flex-column cursor-pointer horse-info-hover"
                    [ngbTooltip]="horseTooltip"
                    placement="right"
                    container="body"
                    tooltipClass="horse-tooltip-wide"
                    (click)="openHorseDetailsModal(registration.horse)">
                    <span class="fw-semibold text-gray-800 text-primary-hover">{{ registration.horse.name }}</span>
                    @if (registration.horse.breed) {
                      <span class="text-muted fs-7">{{ registration.horse.breed }}</span>
                    }
                  </div>
                  <ng-template #horseTooltip>
                    <div class="tooltip-content horse-tooltip-content">
                      <div class="tooltip-header">
                        {{ 'manageEvent.viewRegistrations.horseInfo' | translate }}
                        <span class="tooltip-hint">{{ 'manageEvent.viewRegistrations.clickForMore' | translate }}</span>
                      </div>
                      <div class="tooltip-body">
                        <!-- Basic Info -->
                        <div class="tooltip-section">
                          <div class="tooltip-row">
                            <span class="label">{{ 'horseDetails.name' | translate }}:</span>
                            <span class="value">{{ registration.horse.name }}</span>
                          </div>
                          @if (registration.horse.breed) {
                            <div class="tooltip-row">
                              <span class="label">{{ 'horseDetails.breed' | translate }}:</span>
                              <span class="value">{{ registration.horse.breed }}</span>
                            </div>
                          }
                          @if (registration.horse.color) {
                            <div class="tooltip-row">
                              <span class="label">{{ 'horseDetails.color' | translate }}:</span>
                              <span class="value">{{ registration.horse.color }}</span>
                            </div>
                          }
                          @if (registration.horse.gender !== null && registration.horse.gender !== undefined) {
                            <div class="tooltip-row">
                              <span class="label">{{ 'horseDetails.gender' | translate }}:</span>
                              <span class="value">{{ getGenderLabel(registration.horse.gender) }}</span>
                            </div>
                          }
                          @if (registration.horse.date_of_birth) {
                            <div class="tooltip-row">
                              <span class="label">{{ 'horseDetails.dateOfBirth' | translate }}:</span>
                              <span class="value">{{ formatDateDMYDots(registration.horse.date_of_birth) }} ({{ getHorseAge(registration.horse) }})</span>
                            </div>
                          }
                        </div>
                        <!-- Identification -->
                        @if (registration.horse.passport_id || registration.horse.horse_registry_id) {
                          <div class="tooltip-section">
                            @if (registration.horse.passport_id) {
                              <div class="tooltip-row">
                                <span class="label">{{ 'horseDetails.passportId' | translate }}:</span>
                                <span class="value">{{ registration.horse.passport_id }}</span>
                              </div>
                            }
                            @if (registration.horse.horse_registry_id) {
                              <div class="tooltip-row">
                                <span class="label">{{ 'horseDetails.registryId' | translate }}:</span>
                                <span class="value">{{ registration.horse.horse_registry_id }}</span>
                              </div>
                            }
                          </div>
                        }
                        <!-- Vaccination -->
                        @if (registration.horse.vaccination_date || registration.horse.next_vaccination_date) {
                          <div class="tooltip-section">
                            @if (registration.horse.vaccination_date) {
                              <div class="tooltip-row">
                                <span class="label">{{ 'horseDetails.lastVaccination' | translate }}:</span>
                                <span class="value">{{ formatDateDMYDots(registration.horse.vaccination_date) }}</span>
                              </div>
                            }
                            @if (registration.horse.next_vaccination_date) {
                              <div class="tooltip-row" [class.text-danger]="isVaccinationOverdue(registration.horse)">
                                <span class="label">{{ 'horseDetails.nextVaccination' | translate }}:</span>
                                <span class="value">
                                  {{ formatDateDMYDots(registration.horse.next_vaccination_date) }}
                                  @if (isVaccinationOverdue(registration.horse)) {
                                    <i class="fa fa-exclamation-triangle ms-1"></i>
                                  }
                                </span>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </ng-template>
                } @else {
                  <span class="text-muted">N/A</span>
                }
              </td>
              <td>
                @if (registration.order_id) {
                  <span class="fw-semibold text-gray-700">#{{ registration.order_id }}</span>
                } @else {
                  <span class="text-muted">-</span>
                }
              </td>
              <td>
                @if (registration.payment_status === 'paid') {
                  <span class="badge badge-light-success">{{ 'manageEvent.viewRegistrations.paymentPaid' | translate }}</span>
                } @else if (registration.payment_status === 'pending' || registration.payment_status === 'pay_later') {
                  <span class="badge badge-light-warning">{{ 'manageEvent.viewRegistrations.paymentPending' | translate }}</span>
                } @else if (registration.payment_status === 'refunded') {
                  <span class="badge badge-light-danger">{{ 'manageEvent.viewRegistrations.paymentRefunded' | translate }}</span>
                } @else {
                  <span class="badge badge-light-secondary">{{ 'manageEvent.viewRegistrations.paymentNotRequired' | translate }}</span>
                }
              </td>
              <td>
                @if (registration.created_at) {
                  <span class="text-gray-700">{{ formatDateDMYDots(registration.created_at) }}</span>
                } @else {
                  <span class="text-muted">-</span>
                }
              </td>
              <td>
                @if (registration.notes) {
                  <div
                    class="notes-indicator d-inline-flex align-items-center gap-2 cursor-pointer"
                    [ngbTooltip]="notesTooltip"
                    tooltipClass="notes-tooltip"
                    placement="top"
                    container="body"
                  >
                    <i class="fa fa-comment-dots text-primary"></i>
                    <span class="notes-preview text-muted fs-7">{{ registration.notes.length > 20 ? (registration.notes.slice(0, 20) + '...') : registration.notes }}</span>
                  </div>
                  <ng-template #notesTooltip>
                    <div class="notes-tooltip-content">
                      <div class="notes-tooltip-header">
                        <i class="fa fa-comment-dots me-2"></i>
                        {{ 'manageEvent.viewRegistrations.participantNotes' | translate }}
                      </div>
                      <div class="notes-tooltip-body">{{ registration.notes }}</div>
                    </div>
                  </ng-template>
                } @else {
                  <span class="text-muted">-</span>
                }
              </td>
              <td class="text-center">
                @if (getResultForRegistration(registration)) {
                  @if (getResultForRegistration(registration)!.status === 'recorded') {
                    @if (getResultForRegistration(registration)!.final_time_seconds !== null && getResultForRegistration(registration)!.final_time_seconds !== undefined) {
                      <span class="badge badge-light-success">{{ getResultForRegistration(registration)!.final_time_seconds | number:'1.3-3' }}s</span>
                    } @else if (getResultForRegistration(registration)!.final_points !== null && getResultForRegistration(registration)!.final_points !== undefined) {
                      <span class="badge badge-light-success">{{ getResultForRegistration(registration)!.final_points | number:'1.2-2' }} pts</span>
                    } @else if (getResultForRegistration(registration)!.raw_time_seconds !== null && getResultForRegistration(registration)!.raw_time_seconds !== undefined) {
                      <span class="badge badge-light-success">{{ getResultForRegistration(registration)!.raw_time_seconds | number:'1.3-3' }}s</span>
                    } @else {
                      <span class="badge badge-light-success">{{ 'results.recorded' | translate }}</span>
                    }
                  } @else if (getResultForRegistration(registration)!.status === 'dnf') {
                    <span class="badge badge-light-warning">DNF</span>
                  } @else if (getResultForRegistration(registration)!.status === 'dns') {
                    <span class="badge badge-light-secondary">DNS</span>
                  } @else if (getResultForRegistration(registration)!.status === 'dq') {
                    <span class="badge badge-light-danger">DQ</span>
                  } @else {
                    <span class="badge badge-light-info">{{ getResultForRegistration(registration)!.status }}</span>
                  }
                } @else {
                  <span class="badge badge-light-secondary">{{ 'manageEvent.viewRegistrations.notScored' | translate }}</span>
                }
              </td>
              <td class="text-end">
                <div class="d-flex align-items-center justify-content-end gap-2">
                  @if (getResultForRegistration(registration)?.images?.length) {
                    <button
                      class="btn btn-sm btn-icon btn-light-info"
                      type="button"
                      (click)="viewResultImages(registration)"
                      [ngbTooltip]="'images.viewImages' | translate"
                      placement="top"
                    >
                      <i class="fa fa-image"></i>
                    </button>
                  }
                  <div class="dropdown">
                    <button
                      class="btn btn-sm btn-icon btn-light btn-active-light-primary"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="fa fa-ellipsis-v"></i>
                    </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li>
                      <a class="dropdown-item" (click)="openResultEntryModal(registration)" [class.disabled]="!selectedRound">
                        <i class="fa fa-stopwatch me-2"></i>
                        @if (getResultForRegistration(registration)) {
                          {{ 'results.editResult' | translate }}
                        } @else {
                          {{ 'results.enterResult' | translate }}
                        }
                      </a>
                    </li>
                    @if (registration.payment_status === 'pending' || registration.payment_status === 'pay_later') {
                      <li><hr class="dropdown-divider"></li>
                      <li class="dropdown-header">{{ 'manageEvent.viewRegistrations.markAsPaid' | translate }}</li>
                      @if (hasCustomPayment && customPaymentMethodName) {
                        <li>
                          <a class="dropdown-item" (click)="markAsPaid(registration, 'bank_transfer')">
                            <i class="fa fa-hand-holding-dollar me-2"></i>
                            {{ customPaymentMethodName }}
                          </a>
                        </li>
                      } @else {
                        <li>
                          <a class="dropdown-item" (click)="markAsPaid(registration, 'bank_transfer')">
                            <i class="fa fa-university me-2"></i>
                            {{ 'manageEvent.viewRegistrations.paymentBankTransfer' | translate }}
                          </a>
                        </li>
                        <li>
                          <a class="dropdown-item" (click)="markAsPaid(registration, 'cash')">
                            <i class="fa fa-money-bill me-2"></i>
                            {{ 'manageEvent.viewRegistrations.paymentCash' | translate }}
                          </a>
                        </li>
                        <li>
                          <a class="dropdown-item" (click)="markAsPaid(registration, 'other')">
                            <i class="fa fa-credit-card me-2"></i>
                            {{ 'manageEvent.viewRegistrations.paymentOther' | translate }}
                          </a>
                        </li>
                      }
                    }
                    <li><hr class="dropdown-divider"></li>
                    <li>
                      <a class="dropdown-item" (click)="openEditRegistrationModal(registration)">
                        <i class="far fa-edit me-2"></i>
                        {{ 'manageEvent.viewRegistrations.editRegistration' | translate }}
                      </a>
                    </li>
                    <li><hr class="dropdown-divider"></li>
                    <li>
                      <a class="dropdown-item text-danger" (click)="deleteRegistration(registration)">
                        <i class="far fa-trash-can me-2"></i>
                        {{ 'manageEvent.viewRegistrations.cancelRegistration' | translate }}
                      </a>
                    </li>
                  </ul>
                  </div>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Summary Section -->
    <div class="separator my-6"></div>

    <div class="row g-5">
      <div class="col-md-4">
        <div class="card bg-light-primary">
          <div class="card-body p-5">
            <div class="d-flex align-items-center">
              <i class="fa fa-users fs-2x text-primary me-4"></i>
              <div>
                <div class="fs-7 text-muted">{{ 'manageEvent.viewRegistrations.totalRegistrations' | translate }}</div>
                <div class="fs-2 fw-bold text-gray-800">{{ (eventClass.event_class_registrations?.length || 0) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      @if (eventClass.max_num_registrations) {
        <div class="col-md-4">
          <div class="card bg-light-warning">
            <div class="card-body p-5">
              <div class="d-flex align-items-center">
                <i class="fa fa-chart-line fs-2x text-warning me-4"></i>
                <div>
                  <div class="fs-7 text-muted">{{ 'manageEvent.viewRegistrations.capacity' | translate }}</div>
                  <div class="fs-2 fw-bold text-gray-800">
                    {{ (eventClass.event_class_registrations?.length || 0) }} / {{ eventClass.max_num_registrations }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      @if (eventClass.price) {
        <div class="col-md-4">
          <div class="card bg-light-success">
            <div class="card-body p-5">
              <div class="d-flex align-items-center">
                <i class="fa fa-money-bill fs-2x text-success me-4"></i>
                <div>
                  <div class="fs-7 text-muted">{{ 'manageEvent.viewRegistrations.totalRevenue' | translate }}</div>
                  <div class="fs-2 fw-bold text-gray-800">
                    {{ getNetRevenue() | number:'1.0-0' }} {{ eventClass.price_currency }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>

<div class="modal-footer">
  <app-button
    [variant]="'outline'"
    [label]="'common.close' | translate"
    (clicked)="close()"
  />
  <app-button
    [variant]="'primary'"
    [label]="'manageEvent.viewRegistrations.addRegistration' | translate"
    [iconClass]="'fa fa-user-plus'"
    (clicked)="openAddRegistrationModal()"
  />
</div>
